import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "@/utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/my/reminders/")({
  component: lazyImportRouteComponent(
    () => import("./-components/RemindersPage"),
    "RemindersPage"
  ),
  validateSearch: (search: Record<string, unknown>) => ({
    userId:
      typeof search.userId === "string"
        ? Number.isNaN(Number(search.userId))
          ? undefined
          : Number(search.userId)
        : typeof search.userId === "number"
          ? search.userId
          : undefined,
    showCompleted:
      typeof search.showCompleted === "string"
        ? search.showCompleted === "true"
        : typeof search.showCompleted === "boolean"
          ? search.showCompleted
          : undefined,
    objectTypeId:
      typeof search.objectTypeId === "string"
        ? Number.isNaN(Number(search.objectTypeId))
          ? undefined
          : Number(search.objectTypeId)
        : typeof search.objectTypeId === "number"
          ? search.objectTypeId
          : undefined,
  }),
  beforeLoad: (context) => {
    return {
      getTitle: () =>
        context.context.t ? context.context.t("Reminders") : "Erinnerungen",
    }
  },
})
